import Button from 'components/controls/Button';
import {
   StyledMessagePage,
   StyledMessagePageContainer,
   StyledMessagePageLogo,
   StyledMessagePageLogoContainer,
   StyledMessagePageText,
   StyledMessagePageTextContainer,
   StyledMessagedButton
} from 'shared/styled/message-page.styled';
import { useHistory } from 'react-router-dom';
import i18next, { t } from 'i18next';
import { ConditionalRender } from '../../../../../../components/layout/ConditionalRender';

interface NewIssueSuccessProps {
   onCreateAnother: () => void;
}

export const NewIssueSuccess = ({ onCreateAnother }: NewIssueSuccessProps) => {
   const history = useHistory();

   function handleGoodPracticeClick() {
      history.push('/goodpractice/new');
   }

   function handleOpportunityClick() {
      history.push('/opportunity/new');
   }

   function handleNearMissClick() {
      history.push('/nearmiss/new');
   }

   return (
      <StyledMessagePageContainer>
         <StyledMessagePage>
            <StyledMessagePageLogoContainer>
               <StyledMessagePageLogo />
            </StyledMessagePageLogoContainer>
            <StyledMessagePageTextContainer>
                    <StyledMessagePageText>{'Thank you for your Issue report. This has been submitted for evaluation, and to your depot if one was entered.'}</StyledMessagePageText>
            </StyledMessagePageTextContainer>
            <StyledMessagePageText>
               <StyledMessagedButton>
                  <Button text={t('ObservationPage.NewNearMiss')} onClick={handleNearMissClick} />
               </StyledMessagedButton>
               <StyledMessagedButton>
                  <Button text={t('ObservationPage.NewGoodPractice')} onClick={handleGoodPracticeClick} />
               </StyledMessagedButton>
               <ConditionalRender condition={i18next.language === 'gb'}>
                  <StyledMessagedButton>
                     <Button text={t('ObservationPage.NewIssue')} onClick={onCreateAnother} />
                  </StyledMessagedButton>
                  <StyledMessagedButton>
                     <Button text={t('ObservationPage.NewOpportunity')} onClick={handleOpportunityClick} />
                  </StyledMessagedButton>
               </ConditionalRender>
            </StyledMessagePageText>
         </StyledMessagePage>
      </StyledMessagePageContainer>
   );
};
